module.exports = __webpack_public_path__ + "media/images/app/products/index/styles/bracelets/couture-f1956397ecb20b80f6368fae4004d52f.webp";